import styled from 'styled-components';

import { device } from 'styles/breakpoints';

export const SignUpFormWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
  .sign-up {
    &_title {
      margin-bottom: 8px;
    }
    &-subtitle,
    &-address {
      margin-bottom: 24px;
    }
    &-title,
    &-subtitle,
    &-address {
      color: ${({ theme }) => theme.colors.grayPallet1};
      text-align: center;
    }
  }
  .or-line {
    margin: 24px 0;
    color: ${({ theme }) => theme.colors.grayPallet1};
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    > span {
      width: 25%;
      border: 1px solid ${({ theme }) => theme.colors.whitePallet1};
    }
  }
  .bottom-text {
    padding-top: 24px;
    > p {
      color: ${({ theme }) => theme.colors.gray};
    }
  }
  @media ${device.tablet} {
    width: 100%;
  }
`;

export const SignUpWithCredentialsForm = styled.form`
  > button {
    margin-top: 24px;
  }
`;

export const SignUpWithGoogleFormWrapper = styled.form`
  .and {
    margin: 12px 0;
    color: ${({ theme }) => theme.colors.gray};
    text-align: center;
  }
`;
